export const isUserBlackoutEditEnabled = (userData): string => {
    return userData.isBlackoutEditEnabled;
};
